import React, { useEffect } from "react";
import DropFileContent from "components/market/DropFileContent";

/* 파일 업로드 영역 */
const FileUploadContent = ({ onDrop, inputFiles, updateData }) => {
  useEffect(() => {}, [updateData]);
  return (
    <div className="center w-full md:w-1/2 lg:w-2/3 mx-0.5 mt-1 rounded-lg">
      <div className="w-full">
        {/* 파일 업로드 */}
        {/* inputType 배열 길이의 Dropzone  */}
        {inputFiles && inputFiles.map((m, index) => <DropFileContent {...m} index={index} key={index} onDrop={onDrop} />)}
      </div>
    </div>
  );
};

export default FileUploadContent;
